export class TableSorter {
  private readonly initialSortName: string = '';
  private readonly initialSortOrder: string = 'asc';
  sortName: string = '';
  sortOrder: string = 'asc';

  constructor(sortName: string = '', sortOrder: string = 'asc') {
    this.initialSortName = sortName;
    this.initialSortOrder = sortOrder;
    this.sortName = sortName;
    this.sortOrder = sortOrder;
  }

  reset(): void {
    this.sortName = this.initialSortName;
    this.sortOrder = this.initialSortOrder;
  }
}
